import { CButton } from '@coreui/react';
import * as React from 'react';
import { IMessageBox } from '../abstraction';

interface IProps {
	onPhoto?: (data: string) => void;
	msgBoxProvider: IMessageBox;
}

interface IState {
	isCameraOn: boolean;
}

// 
export class KCamera extends React.Component<IProps, IState> {
	videoRef: React.RefObject<HTMLVideoElement>;
	canvaRef: React.RefObject<HTMLCanvasElement>;
	handleAutofocus: boolean = true;

	public constructor(props: any) {
		super(props);

		this.videoRef = React.createRef<HTMLVideoElement>();
		this.canvaRef = React.createRef<HTMLCanvasElement>();

		this.state = {
			isCameraOn: false
		}
	}

	screenWidth: number;
	screenHeight: number;

	//#region React Hacks

	componentDidMount = () => {
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;
		window.addEventListener('resize', this.updateDimensions);
	}

	componentWillUnmount = () => {
		window.removeEventListener('resize', this.updateDimensions);
	}

	updateDimensions = () => {
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;
		this.forceUpdate();
	};

	//#endregion

	//#region métier

	// Démarrage de la caméra
	startCam = () => {
		try {
			if (navigator.mediaDevices != undefined) {
				navigator.mediaDevices.getUserMedia({
					video: {
						width: this.screenWidth,
						height: this.screenHeight,
						facingMode: { ideal: "environment" },
					},
					audio: false,
				}).then((stream) => {
					this.setState({ isCameraOn: true }, () => {
						// On passe par le callback car il faut que le tag <video> ait été rendu pour pouvoir accéder à videoref
						this.videoRef.current.srcObject = stream
					});
				}).catch((err) => {
					this.props.msgBoxProvider.MessageBox("Error", err, 1);
				});
			}
		}
		catch (err) {
			console.log(err);
		}
	}

	// Arret de la caméra
	stopCam = () => {
		this.videoRef.current.pause();
		(this.videoRef.current.srcObject as MediaStream).getTracks()[0].stop();
		this.setState({ isCameraOn: false });
	}

	// Capture de la vidéo et conversion en image puis appel d'un évènement pour dire qu'on a pris un cliché
	screenShot = () => {
		let context = this.canvaRef.current.getContext("2d");
		context.drawImage(this.videoRef.current, 0, 0, 1920, 1080);
		let image = this.canvaRef.current.toDataURL('image/jpeg', 0.9);
		this.setState({ isCameraOn: false });
		this.stopCam();
		if (this.props.onPhoto) this.props.onPhoto(image);
	}

	//#endregion métier

	//#region Rendus

	renderCamera() {
		if (!this.state.isCameraOn) return "";
		return (
			<div className="KCamera">
				<video ref={this.videoRef} autoPlay={true} width="100%" height="100%" />
				<div className="controls">
					<CButton size="lg" color="success" onClick={() => { this.screenShot(); }}>📷</CButton>
					<CButton size="lg" color="danger" onClick={() => { this.stopCam(); }}>✖</CButton >
				</div>
				<canvas ref={this.canvaRef} width="1680" height="1050" style={{ display: 'none' }} />
			</div>
		);
	}

	render() {
		return (
			<div className="KCameraInput">
				{this.renderCamera()}
				<CButton onClick={() => { this.startCam(); }} >📷</CButton>
			</div>

		)
	}

	//#endregion 
} 
